import tracking from 'dibs-tracking';

const trackingCategory = 'contact dealer';
const locationLabels = {
    pdp: 'more from dealer',
    storefront: 'dealer storefront',
    mc: 'message center',
    mcEmail: 'message center - email',
};

export const onCallModalOpen = location => {
    tracking.trackEvent({
        category: trackingCategory,
        action: 'call dealer clicked',
        label: locationLabels[location],
    });
};

export const onCallModalSuccess = (location, allowDealerCallback) => {
    tracking.trackEvent({
        category: trackingCategory,
        action: 'call dealer initiated',
        label: locationLabels[location],
        value: allowDealerCallback ? 1 : 0,
    });
};
